export interface SolicitacaoFaturaResultado {
  ok?: boolean;
  disparado?: boolean;
  deduplicado?: boolean;
  status?: string;
  mensagem?: string;
  error?: string;
}

export function feedbackSolicitacaoFatura(resultado: SolicitacaoFaturaResultado) {
  const status = resultado.status || '';
  const description = resultado.mensagem || 'Acompanhe o status da solicitação na aba Fatura.';

  if (status === 'AGUARDANDO_VENCIMENTO') {
    return { title: 'Nova solicitação não enviada', description };
  }

  if (status === 'FATURA_RECEBIDA') {
    return { title: 'Fatura já disponível', description };
  }

  if (['AGUARDANDO_ENVIO', 'ENVIADO_N8N', 'PROCESSANDO', 'PROCESSANDO_BEE360', 'EM_VOO'].includes(status)) {
    return {
      title: resultado.disparado ? 'Solicitação enviada ao Bee' : 'Solicitação já em andamento',
      description,
    };
  }

  if (status === 'LIMITE_VOLUME') {
    return { title: 'Solicitação aguardando envio', description };
  }

  if (resultado.deduplicado || resultado.disparado === false) {
    return { title: 'Solicitação não duplicada', description };
  }

  return { title: 'Solicitação enviada ao Bee', description };
}
